import classNames from 'classnames'

export interface ContentProps extends React.ComponentPropsWithoutRef<'div'> {}

export const Content = ({ children, className, ...props }: ContentProps) => {
  return (
    <div
      className={classNames('content-teaser__content', className)}
      {...props}
    >
      {children}
    </div>
  )
}
